import React, { Component } from 'react';
import stickybits from 'stickybits';
import $ from 'jquery';

class MakeSticky extends Component {

    constructor(props){
        super(props);

        this.stickyRef = React.createRef();
    }

    componentDidMount() {
		let self = this;
        let mpu = this.stickyRef.current;    
		
		$(function() {
			self.makeSticky(mpu);
		});
		$(window).resize(function() {
			self.makeSticky(mpu);
		});
    }

    makeSticky(el) {
		var topHeight = (window.innerHeight / 2) - 140.5;
		stickybits(el, {stickyBitStickyOffset: topHeight});
	}

    render(){
        return (
            <div ref={this.stickyRef}>
                { this.props.children }
            </div>
        );
    }
}

export default MakeSticky;